<template>
    <div class="my-account-wrapper">
        <div class="row">
            <div class="col-12">
                <div class="page__head-title page__head-title--orange">
                    <div class="page__head-title__text page__head-title__text--orange">Mon compte</div>
                </div>
            </div>
            <div class="col-12">
                <div class="form_ttl_first">Informations sur votre compte :</div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Nom</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="lastName" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Pr&eacute;nom</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="firstName" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Email</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="email" class="input_n" />
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Garage</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="garage" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Adresse</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="address" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label">Détails de l'adresse</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="addressDetails" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Ville</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="city" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Code postal</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="zip" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">T&eacute;l&eacute;phone</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="officePhone" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
              <div class="form__item">
                <div class="form__item__label form__item__label">Mobile</div>
                <div class="form__item__input-wrapper">
                  <input type="text" v-model="phone" class="input_n" />
                </div>
              </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label">N° RCS</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" disabled v-model="rcs" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label">N° de TVA intracommunautaire</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" disabled v-model="tva" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label">IBAN</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" disabled v-model="iban" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item justify-content-center mt-3 mb-3">
                    <div class="form__item__submit">
                        <input type="button" name="Submit" @click="saveUserDetails" value="Envoyer" class="form_bt form__item__submit__button" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form_ttl">Si vous voulez modifier votre mot de passe:</div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--medium form__item__label--required">Entrez votre mot de passe actuel</div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--medium">
                        <input type="password" v-model="old_password" class="input_n account-password" autocomplete="new-password"/>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--medium form__item__label--required">Entrez votre nouveau mot de passe</div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--medium account-password">
                        <input type="password" v-model="password" class="input_n" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--medium form__item__label--required">Confirmez votre nouveau mot de passe</div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--medium">
                        <input type="password" v-model="password_confirmation" class="input_n account-password" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item justify-content-center mt-3 mb-3">
                    <div class="form__item__submit">
                        <input type="button" name="Submit" @click="saveNewPassword" value="Envoyer" class="form_bt form__item__submit__button" />
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import {validationMixin} from 'vuelidate'
    import {required, email} from 'vuelidate/lib/validators'

    export default {
        name: 'MyAccount',
        data() {
            return {
                firstName: null,
                lastName: null,
                email: null,
                phone: null,
                rcs: null,
                tva: null,
                code: null,
                garage: null,
                address: null,
                addressDetails: null,
                representative: null,
                city: null,
                zip: null,
                officePhone: null,
                old_password: null,
                password: null,
                password_confirmation: null,
                iban: null,
            }
        },
        mixins: [
            validationMixin
        ],
        computed: {
            user() {
                return this.$store.state.userInfo;
            }
        },
        watch: {
            '$store.getters.getAuthUserInfo': function(user) {
                this.parseUser(user);
            }
        },
        methods: {
            parseUser(user) {

                    this.firstName = user.first_name;
                    this.lastName = user.last_name;
                    this.email = user.email;

                    if (user.mechanic) {
                        this.phone = user.mechanic.phone;
                        this.rcs = user.mechanic.rcs;
                        this.tva = user.mechanic.tva;
                        this.officePhone = user.mechanic.office_phone;
                        this.address = user.mechanic.address;
                        this.city = user.mechanic.city;
                        this.zip = user.mechanic.zip;
                        this.code = user.mechanic.code;
                        this.garage = user.mechanic.garage;
                        this.addressDetails = user.mechanic.address_details;
                        // this.representative = user.mechanic.representative.name;
                        this.iban = user.mechanic.iban;
                    }

            },
            saveUserDetails() {
                if (!this.$v.$invalid) {
                    let url = this.user.id + '/update-profile';
                    let data = {
                        first_name: this.firstName,
                        last_name: this.lastName,
                        email: this.email,
                        phone: this.phone,
                        //rcs: this.rcs,
                       // tva: this.tva,
                        office_phone: this.office_phone,
                        address: this.address,
                        city: this.city,
                        zip: this.zip,
                        code: this.code,
                        garage: this.garage,
                        address_details: this.addressDetails,
                        // representative_id: this.representative.id,
                        //iban: this.iban,
                    };

                    this.apiUpdate(url, data).then(response => {
                        this.showSuccessNotification('User details successfully updated.');
                        this.$store.dispatch('updateUserInfo', response.data.user);
                    }).catch(error => {
                        this.showErrorNotification(error);
                    });
                } else {
                    this.showWarningNotification('Please check up that all fields are correct.');
                }
            },
            saveNewPassword() {
                let url = this.user.id + '/change-password';
                let data = {
                    old_password: this.old_password,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                };

                this.apiUpdate(url, data).then(response => {
                    this.showSuccessNotification('User password successfully updated.');
                    this.clearPasswordForm()
                }).catch(error => {
                    this.showErrorNotification(error);
                });
            },
            clearPasswordForm() {
                this.old_password = '';
                this.password = '';
                this.password_confirmation = '';
            }
        },
        mounted() {
            if (this.user) {
                this.parseUser(this.user);
            }
        },
        validations: {
            garage: {
                required
            },
            address: {
                required
            },
            city: {
                required
            },
            zip: {
                required
            },
            officePhone: {
                required
            },
            firstName: {
                required,
            },
            lastName: {
                required,
            },
            email: {
                email
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Profile/MyAccount.vue